import { useState } from "react";
import { useToast } from "@/hooks/use-toast";

export const useSupportBubble = (hasLifetime?: boolean) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showEmailOptions, setShowEmailOptions] = useState(false);
  const { toast } = useToast();
  const supportEmail = "hello@csoagent.com";

  const handleFeedback = () => {
    window.open("https://blocksurvey.io/feedback-form-ZW3MhpExQbCeSDn5380NZA?v=o", "_blank");
    setIsOpen(false);
  };

  const handleEmailOptions = () => {
    setShowEmailOptions(true);
  };

  const handleBooking = () => {
    if (hasLifetime) {
      toast({
        title: "Free Strategy Session",
        description: "As a Lifetime member, please submit a support ticket to claim your free strategy session.",
        duration: 5000,
      });
    } else {
      window.open("https://cal.com/cmpgfb", "_blank");
    }
    setIsOpen(false);
  };

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      toast({
        title: "Email Copied",
        description: "Support email address has been copied to your clipboard.",
        duration: 3000,
      });
    } catch (err) {
      toast({
        title: "Copy Failed",
        description: "Failed to copy email. Please try again.",
        variant: "destructive",
      });
    }
  };

  const handleOpenMailApp = () => {
    window.location.href = `mailto:${supportEmail}`;
    setIsOpen(false);
  };

  const handleBack = () => {
    setShowEmailOptions(false);
  };

  return {
    isOpen,
    setIsOpen,
    showEmailOptions,
    supportEmail,
    handleFeedback,
    handleEmailOptions,
    handleBooking,
    handleCopyEmail,
    handleOpenMailApp,
    handleBack,
  };
};